import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhyChoose } from './components/WhyChoose';
import { Differentials } from './components/Differentials';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <WhyChoose />
      <Differentials />
      <Testimonials />
      <CTA />
      <Footer />
      
      {/* Botão Flutuante WhatsApp */}
      <a
        href="https://wa.me/5511941652251"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 bg-[#25D366] text-white px-6 py-4 rounded-full shadow-2xl hover:bg-[#20BA5A] transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer hover:scale-105 group"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
        <span className="font-medium">Agende Aqui</span>
      </a>
    </div>
  );
}